import "jquery-match-height";
import "readmore-js";
import "gasparesganga-jquery-loading-overlay";
import Swiper from "swiper/bundle";
import tingle from "../../node_modules/tingle.js/dist/tingle.js";

var console = window.console;

var infowindow;
var map;
var mapSingle;
var mapTour;
var mapModal;
var geocoder;
var markers = [];
var markerBounds = [];
var geocoder;

jQuery(window).load(function () {
  var $map = jQuery("#map");
  if ($map.length) {
    initMap();
  }
  var $mapSingle = jQuery("#map-single");
  if ($mapSingle.length) {
    initMapSingle();
  }

  var $mapTour = jQuery("#map-tour");
  if ($mapTour.length) {
    initMapTour();
  }
});

jQuery(document).ajaxSuccess(function () {
  jQuery(".matchheight").matchHeight();
  jQuery(".matchheight-inner").matchHeight();

  initToursProducts();
  initMapSingle();
});

jQuery(document).ready(function () {
  initProductSearch();
  initRouteSearch();
  initImageGallery();
  initArticleFilters();

  initRangeSlider();
  initOwnTours();
  initSaveNotice();

  jQuery(".navbar-toggler").click(function () {
    var $nav = jQuery("#secondary-nav");
    var $body = jQuery("body");
    if ($body.hasClass("menu-open")) {
      $nav.hide();
      $body.removeClass("menu-open");
    } else {
      $nav.show();
      $body.addClass("menu-open");
    }
  });

  jQuery(".myselect").each(function () {
    jQuery(this).select2({
      allowClear: false,
      width: "100%"
    });
  });

  jQuery(".matchheight").matchHeight();
  jQuery(".matchheight-inner").matchHeight();

  if (LANGUAGE == "fi") {
    jQuery(".readmore").readmore({
      collapsedHeight: 200,
      moreLink: '<a href="#" class="readmore-link">Lue lisää</a>',
      lessLink: '<a href="#" class="readmore-link">Piilota</a>',
    });
  } else {
    jQuery(".readmore").readmore({
      collapsedHeight: 200,
      moreLink: '<a href="#" class="readmore-link">Read more</a>',
      lessLink: '<a href="#" class="readmore-link">Hide</a>',
    });
  }

  jQuery(".filters")
    .find("a")
    .click(function () {
      var $filters = jQuery(this).parent();
      if (!$filters) {
        return false;
      }
      var hasMap = $filters.data("has-map");
      if (hasMap) {
        var productListClass = ".product-list";
      } else {
        var productListClass = ".product-list-no-map";
      }
      var $button = jQuery(this);
      jQuery(".filters")
        .find("a")
        .each(function () {
          jQuery(this).removeClass("active");
        });
      if (!$button.hasClass("active")) {
        $button.addClass("active");
      }
      var term_id = $button.data("term-id");
      if (term_id) {
        if (term_id == "all") {
          var $product_list = jQuery(productListClass);
          $product_list.find(".product").each(function () {
            jQuery(this).show();
          });
        } else {
          var $product_list = jQuery(productListClass);
          $product_list.find(".product").each(function () {
            var $product = jQuery(this);
            if ($product.hasClass("term-" + term_id)) {
              $product.show();
            } else {
              $product.hide();
            }
          });
        }
      }
      if (hasMap) {
        initMap();
      }
      initMatchHeight();
    });

  jQuery(".product-map-link").click(function (e) {
    e.preventDefault();
    var id = jQuery(this).data("id");
    if (id) {
      showProductOnMap(id);
    }
  });
});

// KARTTA

function showProductOnMap(id) {
  jQuery(".filters")
    .find("a")
    .each(function () {
      jQuery(this).removeClass("active");
    });

  if (typeof map == "undefined") {
    var oulu = { lat: 65.012, lng: 25.465 };
    map = new google.maps.Map(document.getElementById("map"), {
      zoom: 6,
      maxZoom: 16,
      center: oulu,
    });
  }
  if (typeof geocoder == "undefined") {
    geocoder = new google.maps.Geocoder();
  }

  deleteMarkers();

  var $product = jQuery("#product-" + id);
  if (typeof $product !== "undefined") {
    var coordinates = $product.data("coordinates");
    var address = $product.data("address");

    if (typeof coordinates !== "undefined") {
      var latlng = new google.maps.LatLng(coordinates.lat, coordinates.lng);
      var marker = new google.maps.Marker({
        position: latlng,
        map: map,
      });
      markers.push(marker);
      map.setCenter(latlng);
      map.setZoom(12);
    } else {
      if (typeof address !== "undefined") {
        geocoder.geocode({ address: address }, function (results, status) {
          if (status === "OK") {
            var marker = new google.maps.Marker({
              map: map,
              position: results[0].geometry.location,
            });
            markers.push(marker);
            map.setCenter(results[0].geometry.location);
            map.setZoom(16);
          }
        });
      }
    }

    // tarkistetaan, että näytetäänkö kartta modaalina vai ei
    var showModal = false;
    if (!jQuery("#map").is(":visible")) {
      showModal = true;
    }
    if (showModal) {
      if (typeof mapModal == "undefined") {
        var oulu = { lat: 65.012, lng: 25.465 };
        mapModal = new google.maps.Map(document.getElementById("map-modal"), {
          zoom: 6,
          maxZoom: 16,
          center: oulu,
        });
      }

      setMapOnAll(null);
      var markersModal = [];

      var $product = jQuery("#product-" + id);
      if (typeof $product !== "undefined") {
        var coordinates = $product.data("coordinates");
        var address = $product.data("address");
        var title = $product.data("title");
        if (typeof coordinates !== "undefined") {
          var latlng = new google.maps.LatLng(coordinates.lat, coordinates.lng);
          var marker = new google.maps.Marker({
            position: latlng,
            map: map,
          });
          markersModal.push(marker);
          mapModal.setCenter(latlng);
          mapModal.setZoom(12);
        } else {
          if (typeof address !== "undefined") {
            geocoder.geocode({ address: address }, function (results, status) {
              if (status === "OK") {
                var marker = new google.maps.Marker({
                  map: mapModal,
                  position: results[0].geometry.location,
                });
                markersModal.push(marker);
                mapModal.setCenter(results[0].geometry.location);
                mapModal.setZoom(16);
              }
            });
          }
        }
        if (markersModal.length > 0) {
          for (var i = 0; i < markersModal.length; i++) {
            markersModal[i].setMap(mapModal);
          }
          var bounds = new google.maps.LatLngBounds();
          for (var i = 0; i < markersModal.length; i++) {
            bounds.extend(markersModal[i].getPosition());
          }
          mapModal.fitBounds(bounds);
          var $modal = jQuery("#modal");
          if ($modal.length) {
            $modal.find("#modal-title").html(title);
            $modal.modal("show");
          }
        }
      }
    }
  }
}

function initMapTour() {
  if (typeof infowindow == "undefined") {
    infowindow = new google.maps.InfoWindow();
  }
  var oulu = { lat: 65.012, lng: 25.465 };
  mapTour = new google.maps.Map(document.getElementById("map-tour"), {
    zoom: 6,
    maxZoom: 16,
    center: oulu,
  });

  if (typeof geocoder == "undefined") {
    geocoder = new google.maps.Geocoder();
  }

  deleteMarkers();

  var total_addresses = 0;
  var processed_addresses = 0;

  jQuery(".day-product-list")
    .find(".product")
    .each(function () {
      var $product = jQuery(this);
      if ($product) {
        var coordinates = $product.data("coordinates");
        var address = $product.data("address");
        var title = $product.data("title");
        var url = $product.data("url");
        if (typeof coordinates !== "undefined") {
          var latlng = new google.maps.LatLng(coordinates.lat, coordinates.lng);
          var marker = new google.maps.Marker({
            position: latlng,
            map: mapTour,
            content: title,
            address: address,
            url: url,
          });
          google.maps.event.addListener(marker, "click", function () {
            infowindow.setContent(
              '<a href="' +
                this.url +
                '"><h6>' +
                this.content +
                "</h6></a><p>" +
                this.address +
                "</p>"
            );
            infowindow.open(mapTour, this);
          });
          markers.push(marker);
          markerBounds.push(latlng);
        } else if (typeof address !== "undefined" && !address.isEmpty()) {
          /*
        total_addresses = total_addresses + 1;
        geocoder.geocode({'address': address}, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            var location = results[0].geometry.location;
            if (location) {
              var latlng = new google.maps.LatLng(location.lat(), location.lng());
              var marker = new google.maps.Marker({
                map: mapTour,
                position: location,
                content: title,
                address: address,
                url: url
              });
              google.maps.event.addListener(marker, 'click', function() {
                infowindow.setContent('<a href="' + this.url + '"><h6>' + this.content + '</h6></a><p>' + this.address + '</p>');
                infowindow.open(mapTour, this);
              });
              markers.push(marker);
              processed_addresses = processed_addresses + 1;                
              markerBounds.push(latlng);
              fitAddressesBounds(total_addresses, processed_addresses, mapTour);
            }
          }
        });
        */
        }
      }
    });
  showMarkers(mapTour);
  fitBounds(mapTour);
}

function initMapSingle() {
  if (typeof google == "undefined") {
    return;
  }
  if (typeof mapSingle == "undefined") {
    var oulu = { lat: 65.012, lng: 25.465 };
    mapSingle = new google.maps.Map(document.getElementById("map-single"), {
      zoom: 12,
      maxZoom: 16,
      center: oulu,
    });
  }
  if (typeof geocoder == "undefined") {
    geocoder = new google.maps.Geocoder();
  }

  var coordinates = jQuery("#map-single").data("coordinates");
  var address = jQuery("#map-single").data("address");

  if (typeof coordinates !== "undefined") {
    var latlng = new google.maps.LatLng(coordinates.lat, coordinates.lng);
    var marker = new google.maps.Marker({
      map: mapSingle,
      position: latlng,
    });
    markers.push(marker);
    mapSingle.setCenter(latlng);
  } else {
    if (typeof address !== "undefined") {
      geocoder.geocode({ address: address }, function (results, status) {
        if (status === "OK") {
          var marker = new google.maps.Marker({
            map: mapSingle,
            position: results[0].geometry.location,
          });
          markers.push(marker);
          mapSingle.setCenter(results[0].geometry.location);
        }
      });
    }
  }
}

function initMap() {
  if (typeof map == "undefined") {
    var oulu = { lat: 65.012, lng: 25.465 };
    map = new google.maps.Map(document.getElementById("map"), {
      zoom: 6,
      maxZoom: 16,
      center: oulu,
    });
  }
  if (typeof geocoder == "undefined") {
    geocoder = new google.maps.Geocoder();
  }

  deleteMarkers();

  jQuery(".product-list")
    .find(".product")
    .each(function () {
      var $product = jQuery(this);
      if ($product.is(":visible")) {
        var coordinates = $product.data("coordinates");
        var address = $product.data("address");

        if (typeof coordinates !== "undefined") {
          var latlng = new google.maps.LatLng(coordinates.lat, coordinates.lng);
          var marker = new google.maps.Marker({
            position: latlng,
            map: map,
          });
          markers.push(marker);
        } else {
          if (typeof address !== "undefined") {
            geocoder.geocode({ address: address }, function (results, status) {
              if (status === "OK") {
                var marker = new google.maps.Marker({
                  map: map,
                  position: results[0].geometry.location,
                });
                markers.push(marker);
              }
            });
          }
        }
      }
    });
  showMarkers(map);
}

function hideMarkers() {
  setMapOnAll(null);
}

function deleteMarkers() {
  hideMarkers();
  markers = [];
}

function showMarkers(map) {
  setMapOnAll(map);
  fitBounds(map);
}

function setMapOnAll(map) {
  for (let i = 0; i < markers.length; i++) {
    markers[i].setMap(map);
  }
}

function fitBounds(map) {
  var bounds = new google.maps.LatLngBounds();
  for (var i = 0; i < markers.length; i++) {
    bounds.extend(markers[i].getPosition());
  }
  map.fitBounds(bounds);
}

// TUOTEHAKU

function initProductSearch() {
  var $productSearchResults = jQuery("#product-search-results");
  if ($productSearchResults.length) {
    var data = {
      action: "prt_product_search_results",
      nonce: AJAX_NONCE,
    };
    var parameters = {};
    var q = getUrlParameter("q");
    if (q) {
      parameters["q"] = q;
    }
    var category = getUrlParameter("category");
    if (category) {
      parameters["category"] = category;
    }
    var tag = getUrlParameter("tag");
    if (tag) {
      parameters["tag"] = tag;
    }
    var type = getUrlParameter("type");
    if (type) {
      parameters["type"] = type;
    }
    var type = getUrlParameter("accessible");
    if (type) {
      parameters["accessible"] = 1;
    }
    var certificate = getUrlParameter("certificate");
    if (certificate) {
      parameters["certificate"] = certificate;
    }
    var target_group = getUrlParameter("target_group");
    if (target_group) {
      parameters["target_group"] = target_group;
    }
    var location = getUrlParameter("location");
    if (location) {
      parameters["location"] = location;
    }

    if (!jQuery.isEmptyObject(parameters)) {
      for (var key in parameters) {
        data[key] = parameters[key];
      }
    }

    let filters_set = false;
    for (var key in parameters) {
      if (key) {
        filters_set = true;
        break;
      }
    }

    var tour_id = getUrlParameter("tour_id");
    if (tour_id) {
      data["tour_id"] = tour_id;
      parameters["tour_id"] = tour_id;
    }

    if (tour_id) {
      if (filters_set) {
        getProducts(data);
      }
    } else {
      getProducts(data);
    }

    var $filters = jQuery("#product-search-filters");
    if ($filters) {
      $filters.find('select, input[type="checkbox"]').change(function () {
        filtersChanged();
      });
      var timer = null;
      $filters.find('input[name="q"]').keyup(function () {
        clearTimeout(timer);
        timer = setTimeout(filtersChanged, 1000);
      });
    }
  }
}

function filtersChanged() {
  var parameters = {};
  var data = {
    action: "prt_product_search_results",
    nonce: AJAX_NONCE,
  };
  var $filters = jQuery("#product-search-filters");
  $filters.find("input, select").each(function () {
    var $element = jQuery(this);
    var key = $element.attr("name");

    if (
      key == "type" ||
      key == "category" ||
      key == "location" ||
      key == "target_group"
    ) {
      return;
    }

    var value = "";
    if ($element.prop("tagName") == "SELECT") {
      var value = $element.find("option").filter(":selected").val();
    }
    var type = $element.attr("type");
    if (type == "checkbox") {
      if ($element.is(":checked")) {
        var value = $element.val();
      }
    } else {
      if ($element.prop("tagName") == "INPUT") {
        var value = $element.val();
      }
    }
    if (key.length > 0 && value.length > 0) {
      data[key] = value;
      parameters[key] = value;
    }
  });

  let types = [];
  $filters.find("select[name=type] option:selected").each(function () {
    var value = jQuery(this).val();
    if (value) {
      types.push(value);
    }
  });
  if (types.length) {
    data["type"] = types.toString();
    parameters["type"] = types.toString();
  }

  let categories = [];
  $filters.find("select[name=category] option:selected").each(function () {
    var value = jQuery(this).val();
    if (value) {
      categories.push(value);
    }
  });
  if (categories.length) {
    data["category"] = categories.toString();
    parameters["category"] = categories.toString();
  }

  let locations = [];
  $filters.find("select[name=location] option:selected").each(function () {
    var value = jQuery(this).val();
    if (value) {
      locations.push(value);
    }
  });
  if (locations.length) {
    data["location"] = locations.toString();
    parameters["location"] = locations.toString();
  }

  let target_groups = [];
  $filters.find("select[name=target_group] option:selected").each(function () {
    var value = jQuery(this).val();
    if (value) {
      target_groups.push(value);
    }
  });
  if (target_groups.length) {
    data["target_group"] = target_groups.toString();
    parameters["target_group"] = target_groups.toString();
  }

  /* let filters_set = false;
  for (var key in parameters) {
    if (key) {
      filters_set = true;
      break;
    }
  } */

  var tour_id = getUrlParameter("tour_id");
  if (tour_id) {
    data["tour_id"] = tour_id;
    parameters["tour_id"] = tour_id;
  }

  getProducts(data);

  if (parameters) {
    var newUrl = CURRENT_URL + "/?" + jQuery.param(parameters);
    changeUrl(newUrl);
  }
}

function getProducts(data) {
  jQuery.LoadingOverlay("show");
  var $results = jQuery("#product-search-results");
  if ($results) {
    $results.html("");
    jQuery.ajax({
      url: AJAX_URL,
      data: data,
      success: function (results) {
        $results.html(results);
        jQuery.LoadingOverlay("hide");
      },
    });
  }
}

// URL PARAMETRIT
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");
    if (sParameterName[0] === sParam) {
      return typeof sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

function changeUrl(url) {
  if (typeof history.pushState !== "undefined") {
    var obj = { url: url };
    history.pushState(obj, null, obj.url);
  }
}

// KUVAGALLERIA
function initImageGallery() {
  var swiper = new Swiper(".image-gallery", {
    slidesPerView: 3,
    spaceBetween: 30,
    slidesPerGroup: 3,
    loop: false,
    loopFillGroupWithBlank: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  jQuery(".gallery-image-link").click(function (e) {
    e.preventDefault();
    var src = jQuery(this).data("src");
    var alt = jQuery(this).data("alt");
    if (src) {
      var $mainImage = jQuery("#main-image");
      if ($mainImage) {
        $mainImage.attr("src", src);
        $mainImage.attr("alt", alt);
      }
    }
  });
}

function makeDelay(ms) {
  var timer = 0;
  return function (callback) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
}

function initRouteSearch() {
  var routes = jQuery(".route-list").find(".route-wrapper");
  var filters = jQuery("#route-search-filters");
  if (routes && filters) {
    var select = jQuery(filters).find('select[name="region"]');
    if (select) {
      jQuery(select).change(function () {
        var value = jQuery(this).val();
        if (value == "") {
          jQuery(routes).each(function () {
            jQuery(this).parent().show();
          });
        } else {
          jQuery(routes).each(function () {
            var showRoute = false;
            var region = jQuery(this).data("region");
            if (typeof region !== "undefined") {
              if (region === value) {
                showRoute = true;
              }
            }
            if (showRoute) {
              jQuery(this).parent().show();
            } else {
              jQuery(this).parent().hide();
            }
          });
        }
      });
    }
  }
}

// ARTIKKELIFILTTERIT
function initArticleFilters() {
  if (window.location.hostname == "localhost") {
    if (LANGUAGE == "fi") {
      var url =
        window.location.protocol +
        "//" +
        window.location.hostname +
        "/pohjolanrengastie2022/artikkelit";
    } else {
      var url =
        window.location.protocol +
        "//" +
        window.location.hostname +
        "/pohjolanrengastie2022/articles";
    }
  } else {
    if (LANGUAGE == "fi") {
      var url =
        window.location.protocol +
        "//" +
        window.location.hostname +
        "/ajankohtaista";
    } else {
      var url =
        window.location.protocol +
        "//" +
        window.location.hostname +
        "/articles";
    }
  }

  var $filter_category = jQuery("#article-category-filter");
  $filter_category.change(function () {
    var cat_id = jQuery(this).val();
    if (cat_id) {
      window.location.href = url + "?cat=" + cat_id + "#scroll";
    } else {
      window.location.href = url;
    }
    return;
  });
}

function initMatchHeight() {
  jQuery(".matchheight:visible").matchHeight({
    byRow: true,
  });
  jQuery(".matchheight-image:visible").matchHeight({
    byRow: true,
  });
  jQuery(".matchheight-link:visible").matchHeight({
    byRow: true,
  });
  jQuery(".matchheight-inner:visible").matchHeight({
    byRow: true,
  });
}

function initOwnTours() {
  if (
    !jQuery("body").hasClass("page-template-edit-tour") &&
    !jQuery("body").hasClass("page-template-create-tour") &&
    !jQuery("body").hasClass("page-template-my-tours")
  ) {
    return;
  }
  bindSortable();
  bindTourDayRemoveButtons();
  bindTourProductRemoveButtons();
  bindExpanderButtons();
  jQuery("#tour-add-day").click(function (e) {
    e.preventDefault();
    var $template = jQuery("#tour-day-template");
    if ($template.length) {
      var $container = jQuery("#tour-day-container");
      if ($container.length) {
        var template_html = $template.html();
        if (template_html) {
          var current_indexes = new Array();
          $container.find(".day").each(function () {
            current_indexes.push(jQuery(this).data("index"));
          });
          var next_index = 0;
          if (current_indexes.length == 0) {
            next_index = 1;
          } else {
            var max = Math.max.apply(null, current_indexes);
            if (max == 0) {
              next_index = 1;
            } else {
              next_index = max + 1;
            }
          }
          if (next_index) {
            var template_html = template_html.replace(/INDEX/g, next_index);
            $container.append(template_html);
            bindTourDayRemoveButtons();
            bindTourProductRemoveButtons();
            bindSortable();
            bindExpanderButtons();
          }
        }
      }
    }
  });

  jQuery("#tour-create").click(function (e) {
    e.preventDefault();
    var $form = jQuery("#tour-form");
    if ($form) {
      $form.submit();
    }
  });

  jQuery(".tour-delete").click(function (e) {
    if (LANGUAGE == "fi") {
      if (confirm("Oletko varma, että haluat poistaa suunnitelman?")) {
        return true;
      }
    } else {
      if (confirm("Are you sure you want to delete the tour?")) {
        return true;
      }
    }
    return false;
  });

  jQuery("#tour-save").click(function (e) {
    e.preventDefault();
    jQuery(window).unbind("beforeunload");
    jQuery("#tour-day-container")
      .find(".day")
      .each(function () {
        var product_ids = new Array();
        jQuery(this)
          .find("ul.day-products li.day-product")
          .each(function () {
            var product_id = jQuery(this).data("product-id");
            if (product_id) {
              product_ids.push(product_id);
            }
          });
        var $select = jQuery(this).find(".product-select");
        if ($select) {
          $select.empty();
          if (product_ids.length) {
            for (var i = 0; i < product_ids.length; i++) {
              $select.append(
                '<option value="' +
                  product_ids[i] +
                  '" selected="selected">' +
                  product_ids[i] +
                  "</option>"
              );
            }
          }
        }
      });
    var product_ids = new Array();
    var $product_pool = jQuery("#product-pool");
    var tour_id = $product_pool.data("tour-id");
    if (tour_id) {
      $product_pool.find(".day-product").each(function () {
        var product_id = jQuery(this).data("product-id");
        if (product_id) {
          product_ids.push(product_id);
        }
      });
      jQuery.ajax({
        type: "POST",
        url: AJAX_URL,
        xhrFields: {
          withCredentials: true,
        },
        cache: false,
        data: {
          action: "my_tour_update_product_pool",
          tour_id: tour_id,
          product_ids: product_ids,
        },
        success: function (response) {
          if (response == "OK") {
            var $form = jQuery("#tour-form");
            if ($form) {
              $form.submit();
            }
          } else {
            alert("Something went wrong while saving the tour.");
          }
        },
      });
    }
  });
}

function refreshProductPool() {
  var $product_pool = jQuery("#product-pool");
  if ($product_pool) {
    var tour_id = $product_pool.data("tour-id");
    if (tour_id) {
      var current_day_product_ids = new Array();
      jQuery("#tour-day-container")
        .find(".day")
        .each(function () {
          jQuery(this)
            .find("ul.day-products li.day-product")
            .each(function () {
              var product_id = jQuery(this).data("product-id");
              if (product_id) {
                current_day_product_ids.push(product_id);
              }
            });
        });
      jQuery.ajax({
        type: "POST",
        url: AJAX_URL,
        xhrFields: {
          withCredentials: true,
        },
        cache: false,
        data: {
          action: "my_tour_refresh_product_pool",
          tour_id: tour_id,
          current_day_product_ids: current_day_product_ids,
        },
        success: function (response) {
          if (response !== "ERROR") {
            $product_pool.html(response);
            bindTourProductRemoveButtons();
          }
        },
      });
    }
  }
}

function initToursProducts() {
  alertify.set("notifier", "position", "bottom-center");
  jQuery(".tour-product-add-button")
    .unbind("click")
    .click(function (e) {
      e.preventDefault();
      var $button = jQuery(this);
      if ($button.attr("disabled")) {
        return;
      }
      var nonce = jQuery(this).data("nonce");
      if (nonce) {
        var post_id = $button.data("post-id");
        if (post_id) {
          var success = $button.data("success");
          $button.attr("disabled", "disabled");
          var tour_id = $button.data("tour-id");
          if (tour_id) {
            jQuery.ajax({
              type: "POST",
              url: AJAX_URL,
              xhrFields: {
                withCredentials: true,
              },
              cache: false,
              data: {
                action: "my_tour_add_product",
                post_id: post_id,
                tour_id: tour_id,
                nonce: nonce,
              },
              success: function (response) {
                if (response == "OK") {
                  $button.addClass("added");
                  alertify.notify(success, "success", 5);
                  refreshProductPool();
                }
              },
            });
          }
        }
      }
    });
    initPopups();
}

function bindSortable() {
  var sortableList = document.getElementById("tour-day-container");
  if (sortableList) {
    Sortable.create(sortableList);
  }

  var sortableProductPool = document.getElementById("product-pool");
  if (sortableProductPool) {
    Sortable.create(sortableProductPool, {
      group: {
        name: "day-products",
        pull: "clone",
        put: false,
      },
      ghostClass: "ghost",
    });
  }
  var sortableDayProducts = document.getElementsByClassName("day-products");
  if (sortableDayProducts.length) {
    for (var i = 0; i < sortableDayProducts.length; i++) {
      Sortable.create(sortableDayProducts[i], {
        group: {
          name: "day-products",
        },
        ghostClass: "ghost",
      });
    }
  }
}

function bindTourDayRemoveButtons() {
  jQuery(".tour-remove-day").each(function () {
    jQuery(this)
      .unbind("click")
      .click(function (e) {
        e.preventDefault();
        if (LANGUAGE == "fi") {
          var ok = confirm("Oletko varma, että haluat poistaa päivän?");
        } else {
          var ok = confirm("Are you sure you want to remove the day?");
        }
        if (ok) {
          var index = jQuery(this).data("index");
          var $day = jQuery('.day[data-index="' + index + '"]');
          if ($day.length) {
            var $product_pool = jQuery("#product-pool");
            if ($product_pool) {
              $day.find("ul.day-products li.day-product").each(function () {
                jQuery(this).appendTo($product_pool);
              });
            }
            $day.fadeOut(function () {
              jQuery(this).remove();
            });
          }
        }
      });
  });
}

function bindTourProductRemoveButtons() {
  jQuery(".product-remove").each(function () {
    jQuery(this)
      .unbind("click")
      .click(function (e) {
        e.preventDefault();
        if (LANGUAGE == "fi") {
          var ok = confirm("Oletko varma, että haluat poistaa tuotteen?");
        } else {
          var ok = confirm("Are you sure you want to remove the product?");
        }
        if (ok) {
          var $item = jQuery(this).parent();
          if ($item) {
            $item.fadeOut(function () {
              jQuery(this).remove();
            });
          }
        }
      });
  });
}

function initRangeSlider() {
  jQuery(
    jQuery("#tour-duration-days").html(jQuery("#tour-duration-slider").val())
  );
  jQuery("#tour-duration-slider").on("input", function () {
    jQuery("#tour-duration-days").html(jQuery(this).val());
  });
}

function initSaveNotice() {
  if (!jQuery("body").hasClass("page-template-edit-tour")) {
    return;
  }
  jQuery(window).bind("beforeunload", function () {
    return true;
  });
}

function bindExpanderButtons() {
  jQuery(".expander")
    .find("a")
    .click(function (e) {
      e.preventDefault();
      var $showBtn = jQuery(this).parent().find("a.btn-show");
      var $hideBtn = jQuery(this).parent().find("a.btn-hide");

      var collapse_id = jQuery(this).data("collapse-id");

      if (jQuery(this).hasClass("btn-show")) {
        jQuery("#" + collapse_id).addClass("show");
        $showBtn.hide();
        $hideBtn.show().css("display", "inline-block");
      }
      if (jQuery(this).hasClass("btn-hide")) {
        jQuery("#" + collapse_id).removeClass("show");
        $showBtn.show().css("display", "inline-block");
        $hideBtn.hide();
      }
    });
}

var modal = null;

function initPopups() {
  if (! modal) {
    if (LANGUAGE == 'fi') {
      var closeText = 'Sulje';
    } else {
      var closeText = 'Close';
    }
    modal = new tingle.modal({
      footer: false,
      closeMethods: ['button', 'escape'],
      closeLabel: closeText,
    });
  }

  jQuery('.product-search-results-with-popups').find('.product').find('.footer').find('.btn').each(function() {
    jQuery(this).click(function(e) {
      e.preventDefault();
      var url = jQuery(this).attr('href');
      if (url) {
        modal.setContent('<iframe src="' + url + '" width="100%" height="640"></iframe>');
        modal.open();
      }
    });
  });
}